import { Badge } from "../ui/badge";

export function NaBadge() {
  return <Badge className="bg-gray-600 text-white opacity-25">N/A</Badge>;
}
